import useTranslation from 'next-translate/useTranslation';
import React, { Fragment, useCallback } from 'react';
import { Tyre } from 'types/Tyres';
import { SelectItem } from '../CategoryFilter.styled';

type Props = {
  tyres: Tyre[];
  selectedDiameter: number | null;
  selectedHeight: number | null;
  selectedWidth: number | null;
  setSelectedDiameter: React.Dispatch<React.SetStateAction<number | null>>;
  setSelectedHeight: React.Dispatch<React.SetStateAction<number | null>>;
  setSelectedWidth: React.Dispatch<React.SetStateAction<number | null>>;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
};

export default React.memo(function TyreFilter({
  tyres,
  selectedDiameter,
  selectedHeight,
  selectedWidth,
  setSelectedDiameter,
  setSelectedHeight,
  setSelectedWidth,
  setCurrent,
}: Props) {
  const { t } = useTranslation('common');

  const diameterOptions = tyres.map((diameter) => ({
    label: diameter.diameter,
    value: diameter.id,
  }));

  const getHeightOptions = useCallback(
    (diameterId: number | null) => {
      return diameterId
        ? tyres
            .find((diameter) => diameter.id === diameterId)
            ?.height.map((height) => ({
              label: height.height,
              value: height.id,
            }))
        : undefined;
    },
    [tyres]
  );

  const getWidthsOptions = useCallback(
    (diameterId, heightId) => {
      return tyres
        .find((diameter) => diameter.id === diameterId)
        ?.height.find((height) => height.id === heightId)
        ?.width.map((width) => ({
          label: width.width,
          value: width.id,
        }));
    },
    [tyres]
  );

  return (
    <Fragment>
      <SelectItem
        placeholder={t('select-rim')}
        value={diameterOptions.find((diam) => diam.value === selectedDiameter)}
        options={diameterOptions}
        isClearable
        onChange={(option: any) => {
          setSelectedDiameter(option?.value || null);
          setCurrent(1);
          setSelectedHeight(null);
          setSelectedWidth(null);
        }}
      />
      <SelectItem
        placeholder={t('select-height')}
        isDisabled={!Boolean(selectedDiameter)}
        value={getHeightOptions(selectedDiameter)?.find((height) => height.value === selectedHeight) || null}
        options={getHeightOptions(selectedDiameter)}
        onChange={(option: any) => {
          setSelectedHeight(option.value);
          setCurrent(1);
          setSelectedWidth(null);
        }}
      />
      <SelectItem
        placeholder={t('select-width')}
        isDisabled={!Boolean(selectedHeight)}
        value={
          getWidthsOptions(selectedDiameter, selectedHeight)?.find((width) => width.value === selectedWidth) || null
        }
        options={getWidthsOptions(selectedDiameter, selectedHeight)}
        onChange={(option: any) => {
          setSelectedWidth(option.value);
          setCurrent(1);
        }}
      />
    </Fragment>
  );
});
